<template>
	<ui-modal @toggle="$emit('toggle')">
		<Head title="Création d'un contact" />
		<form method="post" @submit.prevent="handleSubmit" class="flex flex-col lg:grid lg:grid-cols-2 gap-2">
			<ui-title textSize="big" textPosition="left" class="lg:col-span-2 text-slate-700">
				<template v-slot:text>
					<p>Ajouter un utilisateur</p>
				</template>
			</ui-title>
			<form-input placeholder="Prénom *" v-model="form.first_name"></form-input>
			<form-input placeholder="Nom *" v-model="form.last_name"></form-input>
			<form-input placeholder="Téléphone *" v-model="form.phone"> </form-input>
			<form-input placeholder="E-mail *" v-model="form.email" type="mail"> </form-input>
			<form-input placeholder="Mot de passe *" v-model="form.password" type="password" class="col-span-2"> </form-input>
			<form-input placeholder="Confirmer le mot de passe *" v-model="form.confirm_password" type="password" class="col-span-2"> </form-input>
			<form-select placeholder="Role *" @valueChange="form.role = $event" class="col-span-2" :items="roles" :value="form.role">
				<template v-if="form.role === 'user'" v-slot:icon><i class="far fa-user"></i></template>
				<template v-else-if="form.role === 'admin'" v-slot:icon><i class="fas fa-user-shield"></i></template>
			</form-select>
			<form-validation-errors class="lg:col-span-2"></form-validation-errors>
			<ui-button class="col-span-2 mt-3 font-bold border-2" position="center" @click.prevent="handleSubmit()" :loading="loading">
				<template v-slot:text>Valider</template>
			</ui-button>
		</form>
	</ui-modal>
</template>

<script setup>
	import { ref } from 'vue';
	import { Head, useForm } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';

	const emit = defineEmits(['toggle']);

	const props = defineProps({
		statuses: {
			type: Object,
			default: () => ({}),
		},
		skillsList: {
			type: Object,
			default: () => ({}),
		},
	});

	const loading = ref(false);

	const roles = ref([
		{ value: 'admin', name: 'Administrateur' },
		{ value: 'user', name: 'Utilisateur' },
		{ value: 'headExec', name: 'Chef de service' },
		{ value: 'doctor', name: 'Médecin' },
		{ value: 'careExec', name: 'Cadre de soin' },
	]);

	const form = useForm({
		first_name: null,
		last_name: null,
		email: null,
		phone: null,
		password: null,
		confirm_password: null,
		role: null,
	});

	const handleSubmit = () => {
		loading.value = true;
		form.post(route('admin.users.store'), {
			preserveScroll: true,
			onSuccess: () => {
				window.location = route('admin.users.index');
				toast.success('Utilisateur créé avec succès !');
			},
			onFinish: () => {
				loading.value = false;
			},
		});
	};
</script>
